import { Component, OnInit } from '@angular/core';
import { IStepValidation, WizardStep } from '../../WizardStep';
import { WizardService } from '../../wizard.service';

@Component({
  selector: 'app-content-code-selector-step',
  templateUrl: './content-code-selector-step.component.html',
  styleUrls: ['./content-code-selector-step.component.scss'],
})
export class ContentCodeSelectorStepComponent implements OnInit, WizardStep {
  static STEP_NAME: 'select-content-code';

  wizardData: { [p: string]: any };

  contentCode: string;

  constructor(private readonly wizardService: WizardService) {}

  ngOnInit() {
    this.wizardService.disableNextButton();
    if (
      this.wizardData[ContentCodeSelectorStepComponent.STEP_NAME] &&
      typeof this.wizardData[ContentCodeSelectorStepComponent.STEP_NAME] !==
        'object'
    ) {
      this.contentCode =
        this.wizardData[ContentCodeSelectorStepComponent.STEP_NAME];
    }
  }

  provideData(): any {
    return this.contentCode;
  }

  async validate(): Promise<IStepValidation> {
    return {
      success: true,
    };
  }

  contentCodeChange(value) {
    this.wizardService.setNextButtonState(!!value);
    this.contentCode = value;
  }
}
